import {toggleMark} from "prosemirror-commands";
import AbstractMark from "./AbstractMark";

export default class Underline extends AbstractMark {
    get name() {
        return "underline";
    }

    get schema() {
        return {
            parseDOM: [{tag: "u"}, {
                style: "text-decoration", getAttrs: value => value === "underline"
            }],
            toDOM: () => ["u", 0]
        }
    }

    get toMarkdown() {
        return {
            open: "<u>",
            close: "</u>",
            mixable: true,
            expelEnclosingWhitespace: true
        }
    }

    get parseMarkdown() {
        return {
            mark: "underline"
        }
    }

    keys({type}) {
        return {
            "Mod-u": toggleMark(type),
            "Mod-U": toggleMark(type)
        };
    }
}